/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderComponentHeathSummary } from './providerComponentHeathSummary';
import { ProviderComponentHealthDetails } from './providerComponentHealthDetails';


export interface ProviderComponentHealthSummaryAndDetails { 
    details?: Array<ProviderComponentHealthDetails>;
    summary?: Array<ProviderComponentHeathSummary>;
}

